import { format, parseISO } from "date-fns";

export const mapProperties = (src, dest) => {
    for (var prop in src) {
        if (src.hasOwnProperty(prop)) {
            dest[prop] = src[prop];
        }
    }
    return dest;
}

export const isObjectModified = (src, current) => {
    if((!src && current) || (src && !current))
        return true;
        
    for (var prop in current) {
        if (current.hasOwnProperty(prop)) {
            if(Array.isArray(current[prop])){
                const array1 = src[prop];
                const array2 = current[prop];
                if(array1?.length !== array2?.length || !array1.every((value, index) => value === array2[index])){
                    return true;
                }
            } else if(typeof current[prop] === 'object' && current[prop] !== null){
                const scan = isObjectModified(current[prop], src[prop]);
                if(scan === true)
                    return true;
            }else {
                if(src[prop] !== current[prop]){
                    if(src[prop]?.length === 20 && src[prop]?.charAt(19) === "Z"){
                        if(format(parseISO(src[prop]), "yyyy-MM-dd") !== format(parseISO(current[prop]), "yyyy-MM-dd"))
                            return true;
                    } else
                    return true;
                }
            }
        }
    }
    return false;
}